// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"415":"2a388de1","787":"3e13a9e9"}[chunkId] + ".chunk.js";
};